export default __webpack_public_path__ + "static/media/info_ic.9c5e2da1.svg";